import { Component, inject, OnInit } from '@angular/core';

import { RegisterComponent } from '../../components/component-lookup';
import { UserService } from '../../../shared/services/user.service';
import { PeerComparisonInstitutionComponent } from '../peer-comparison-institution/peer-comparison-institution.component';
import { PeerComparisonMultiComponent } from '../peer-comparison-multi/peer-comparison-multi.component';
import { BannerMessageComponent } from '../banner-message/banner-message.component'

@RegisterComponent('PeerComparisonPanel')
@Component({
  selector: 'app-peer-comparison-panel',
  standalone: true,
  imports: [PeerComparisonInstitutionComponent, PeerComparisonMultiComponent, BannerMessageComponent],
  templateUrl: './peer-comparison-panel.component.html',
  styleUrl: './peer-comparison-panel.component.scss'
})
export class PeerComparisonPanelComponent implements OnInit {
  readonly user = inject(UserService).state;
  readonly userProducts = inject(UserService).userProducts;

  public hasPeerComparison: boolean = false;
  public hasNonMaturity: boolean = false;
  public hasBothProducts: boolean = false;
  public hasNoProducts: boolean = false;

  ngOnInit(): void {
    this.hasPeerComparison = this.userProducts().some(c => c.clientCode == 'peer-comparison');
    this.hasNonMaturity = this.userProducts().some(c => c.clientCode == 'non-maturity-deposits');
    this.hasBothProducts = this.hasNonMaturity && this.hasPeerComparison;
    this.hasNoProducts = !this.hasNonMaturity && !this.hasPeerComparison;
  }

}
